import { useNavigate, NavLink, useParams, useSearchParams } from 'react-router-dom';
import {
	Layout,
	message,
	Row,
	Col,
	Card,
	Form,
	Input,
	Button,
	Space,
	Typography,
	Divider,
	Checkbox
} from 'antd';
import { login, resetPasswordRedux, userRegister } from '../../store/auth/actions';
import { useDispatch } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { CheckCircleFilled, CheckCircleOutlined, LockOutlined } from '@ant-design/icons';
import { reset } from 'numeral';
import { useState } from 'react';
const logoBE = require('../../assets/onboarding/logoBE.png');
const EV = require('../../assets/EngelLogo.png');
const EVMoBile = require('../../assets/EngelLogoMobile.png');

const { Content } = Layout;
const { Text } = Typography;

const RegisterUSer = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [reset, setReset] = useState('#808080');

	const [searchParams] = useSearchParams();
	const token = searchParams.get('token');
	const email = searchParams.get('email');
	const [check, setCheck] = useState(false);
	const [loading, setLoading] = useState(false);
	const [checkStates, setCheckStates] = useState({
		minLength: '#808080', // Mínimo 8 caracteres
		maxLength: '#808080', // Máximo 16 caracteres
		lowercase: '#808080', // Mínimo una minúscula
		uppercase: '#808080', // Mínimo una mayúscula
		number: '#808080', // Mínimo un número
		special: '#808080', // Mínimo un símbolo o carácter especial
		noSpace: '#808080' // Sin espacios en blanco
	});

	const onFinish = async (values) => {
		if (loading) return;
		const isValid = Object.values(checkStates).every((color) => color === '#477306');
		if (isValid && values.password1 === values.password2) {
			setReset('#477306');
			setLoading(true);

			try {
				const tmp = await dispatch(userRegister(data));
				if (tmp) {
					navigate('/login');
				}
			} finally {
				setLoading(false);
			}
		} else {
			message.error('Contraseña inválida ❌');
			setReset('#808080');
		}
	};

	const onFinishFailed = () => {
		message.error('Debe completar todos los datos');
	};

	const onPasswordChange = (password) => {
		setCheckStates({
			minLength: password.length >= 8 ? '#477306' : '#808080', // Mínimo 8 caracteres
			maxLength: password.length <= 16 ? '#477306' : '#808080', // Máximo 16 caracteres
			lowercase: /[a-z]/.test(password) ? '#477306' : '#808080', // Mínimo una minúscula
			uppercase: /[A-Z]/.test(password) ? '#477306' : '#808080', // Mínimo una mayúscula
			number: /\d/.test(password) ? '#477306' : '#808080', // Mínimo un número
			special: /[\W_]/.test(password) ? '#477306' : '#808080', // Mínimo un símbolo o carácter especial
			noSpace: !/\s/.test(password) ? '#477306' : '#808080' // Sin espacios
		});
	};

	return (
		<Layout
			style={{
				width: isMobileOnly ? 400 : undefined,
				marginTop: -5,
				background: '#FCFAF5'
			}}>
			<div style={{ height: isMobileOnly ? 56 : 68, background: 'white' }}>
				<div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
					{isMobileOnly ? (
						<img src={EVMoBile} alt="EV" style={{ width: 109, height: 24 }}></img>
					) : (
						<img src={EV} alt="EV" style={{ width: 212, height: 16 }}></img>
					)}
				</div>
			</div>
			<Content
				style={{
					marginTop: !isMobileOnly ? '5%' : undefined,

					height: !isMobileOnly ? '100vh' : undefined,
					padding: isMobileOnly && 24,
					height: '100vh',
					marginRight: !isMobileOnly ? undefined : 8
				}}>
				<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
					<Text style={{ fontSize: isMobileOnly ? 20 : 32, fontWeight: 700, color: '#262626' }}>
						{t('reset.pass')}
					</Text>
				</div>
				<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
					<Text style={{ fontSize: isMobileOnly ? 14 : 16, fontWeight: 400, color: '#808080' }}>
						{t('reset.pass2')}
					</Text>
				</div>
				<Row justify="space-around" align="middle">
					<Col lg={6} md={12} xs={24} sm={24}>
						<Card className="card-login">
							<Form name="login" onFinish={onFinish} onFinishFailed={onFinishFailed}>
								<Form.Item
									name="password1"
									rules={[
										{
											required: true,
											message: 'Por favor, introduzca su contraseña'
										}
									]}>
									<Input.Password
										onChange={(e) => onPasswordChange(e.target.value)}
										className={'login-input'}
										placeholder={t('login.passAccess')}
									/>
								</Form.Item>
								<Form.Item
									name="password2"
									rules={[
										{
											required: true,
											message: 'Por favor, introduzca su contraseña'
										}
									]}>
									<Input.Password className={'login-input'} placeholder={t('login.passAccess')} />
								</Form.Item>
								<Form.Item
									name="check"
									rules={[
										{
											required: true,
											message: 'Por favor, acepte los términos y condiciones'
										}
									]}
									style={{ marginTop: -20 }}>
									<div style={{ display: 'flex', marginTop: 16 }} className="register2">
										<Checkbox onChange={() => setCheck(!check)}></Checkbox>
										&nbsp;&nbsp;
										<span
											className="check-register"
											dangerouslySetInnerHTML={{ __html: t('register.legalTermsEV') }}
											style={{ fontSize: 16, fontWeight: 400 }}></span>
									</div>
								</Form.Item>

								<Form.Item>
									<Button
										htmlType="submit"
										block
										className="button-secundary-ev"
										style={{ height: isMobileOnly && 48, marginTop: isMobileOnly ? 0 : 40 }}
										loading={loading}>
										{t('resetPassword.buttonTitle')}
									</Button>
								</Form.Item>
							</Form>
						</Card>

						{!isMobileOnly && (
							<div style={{ display: 'flex', marginTop: 32 }}>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.minLength,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min1')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.lowercase,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min2')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.uppercase,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min3')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.number,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>{' '}
										{t('check.min4')}
									</Text>
								</div>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.special,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min5')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.noSpace,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min6')}
									</Text>
									<Text
										style={{
											fontSize: 14,
											fontWeight: 400,
											color: checkStates.maxLength,
											marginLeft: 8
										}}>
										<CheckCircleOutlined style={{ marginRight: 4 }}></CheckCircleOutlined>
										{t('check.min7')}
									</Text>
								</div>
							</div>
						)}
					</Col>
				</Row>
			</Content>
		</Layout>
	);
};

export default RegisterUSer;
